interface SelectBackofficeRouterParams {
  mode: string
  hiveUrl?: string
  optIn: unknown
  isBetaTester?: boolean
}

export interface BackofficeRouterSelection {
  router: 'apollo' | 'hive'
  url?: string
}

export const selectBackofficeRouter = ({
  mode,
  hiveUrl,
  optIn,
  isBetaTester = false,
}: SelectBackofficeRouterParams): BackofficeRouterSelection => {
  if (optIn === false || !hiveUrl) return { router: 'apollo' }

  if (mode === 'development' || (mode === 'production' && isBetaTester)) {
    return { router: 'hive', url: hiveUrl }
  }

  return { router: 'apollo' }
}
